export default "__VITE_ASSET__7a12c9ec__"